import { render, staticRenderFns } from "./CMAttachmentsCreateInvoice.vue?vue&type=template&id=cff748e4&scoped=true&"
import script from "./CMAttachmentsCreateInvoice.vue?vue&type=script&lang=js&"
export * from "./CMAttachmentsCreateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CMAttachmentsCreateInvoice.vue?vue&type=style&index=0&id=cff748e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff748e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff748e4')) {
      api.createRecord('cff748e4', component.options)
    } else {
      api.reload('cff748e4', component.options)
    }
    module.hot.accept("./CMAttachmentsCreateInvoice.vue?vue&type=template&id=cff748e4&scoped=true&", function () {
      api.rerender('cff748e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attachments/CMAttachmentsCreateInvoice.vue"
export default component.exports